import type { PromocodesFilterInputType } from "@/types/graphql/partner.generated";

/**
 * Значения фильтра из querystring в аргумент `promocodes(filter:)`. Единая
 * сборка для списка и кнопки отчёта.
 */
export function buildPromocodesFilter(
  filter: Record<string, unknown>
): PromocodesFilterInputType {
  return {
    search: filter.search as string | undefined,
    promocodeCampaignIds: filter.promocodeCampaignIds as string[] | undefined,
  };
}
